import * as React from 'react';
import {
  Box,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import type ICompanyContactDetails from './CompanyInterfaces';

interface CompanyTagsProps {
  formValues: ICompanyContactDetails;
  setFormValues: (formValues: ICompanyContactDetails) => void;
  handleRemove: (index: number) => void;
}

const tags: React.FC<CompanyTagsProps> = ({
  formValues: companyFormValues, setFormValues: setCompanyFormValues, handleRemove,
}) => (
  <>
    {companyFormValues.tags?.map((tag, tagIndex) => (
      <Grid container>
        <Grid item lg={4}>
          <Box p={2}>
            <TextField
              value={tag.key}
              id={`tag${tagIndex}-key-input`}
              required
              label="Key"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempTagValues = companyFormValues.tags;
                tempTagValues[tagIndex].key = inputVal;
                setCompanyFormValues({ ...companyFormValues, tags: tempTagValues });
                console.log(companyFormValues.tags);
              }}
            />
          </Box>
        </Grid>
        <Grid item lg={4}>
          <Box p={2}>
            <TextField
              value={tag.value}
              id={`tag${tagIndex}-value-input`}
              required
              label="Value"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                const tempTagValues = companyFormValues.tags;
                tempTagValues[tagIndex].value = inputVal;
                setCompanyFormValues({ ...companyFormValues, tags: tempTagValues });
                console.log(companyFormValues.tags);
              }}
            />
          </Box>
        </Grid>
        <Grid item>
          <Box display="flex" p={2}>
            <FormControlLabel
              label="Inheritable"
              control={(
                <Checkbox
                  checked={tag.inheritable}
                  color="primary"
                  size="small"
                  id={`${tagIndex}-inheritable-radio-button`}
                  onClick={() => {
                    const tempTagValues = companyFormValues.tags;
                    tempTagValues[tagIndex].inheritable = !companyFormValues.tags[tagIndex].inheritable;
                    setCompanyFormValues({ ...companyFormValues, tags: tempTagValues });
                  }}
                />
              )}
            />
            <Tooltip title="Remove Tag" placement="top">
              <IconButton onClick={() => { handleRemove(tagIndex); }} style={{ color: '#6CAE75', float: 'right' }} disabled={false}>
                <RemoveCircleIcon fontSize="large" />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
    ))}
  </>
);

export default tags;
